"use strict";

import PriceForQuantity from './priceForQuanity';
import Validation from './validation';

export default function(inputElement, productPricing){
    var qty = 0,
        price = 0,
        minimumQty = inputElement.getAttribute('data-minimum') || '',
        multiplesOf = inputElement.getAttribute('data-multiples-of') || '',
        allowZeroQty = inputElement.hasAttribute('data-allow-zero-qty');

    if(inputElement.type === 'text'){
        if(productPricing.length > 0){
            qty = inputElement.value;
            if(Validation.isMinQty(qty, minimumQty, allowZeroQty)){
                if(Validation.isQtyMultipleOf(qty, minimumQty, multiplesOf))
                    price = PriceForQuantity(qty, productPricing) * qty;
            }
        }
    }
    else{
        if(typeof inputElement.options[inputElement.selectedIndex] !== 'undefined')
            price = inputElement.options[inputElement.selectedIndex].getAttribute('data-price');
    }
    return price;
};
